<template>
<div data-module="matter-social-media-sharing">
  <div class="module-layout">
    <div class="content-container" :class="containerClasses">
      <h2>Share</h2>
      <social-sharing
        :url="href"
        :title="shareTitle"
        :description="shareDescription"
        twitter-user="ParticleDesign_"
        inline-template
      >
        <div class="network-shares">
          <network network="facebook" data="">
            <img class="icon" :style="iconStyles" src="/static/assets/facebook.svg" alt="facebook icon" />
          </network>
          <network network="twitter">
            <img class="icon" :style="iconStyles" src="/static/assets/twitter.svg" alt="twitter icon" />
          </network>
          <network network="linkedin">
            <img class="icon" :style="iconStyles" src="/static/assets/linkedin.svg" alt="linkedin icon" />
          </network>
        </div>
      </social-sharing>
    </div>
  </div>
</div>
</template>

<script>
/*
  Matter section Social Media Sharing

  data record: (article record)
  {
    title: <string>
    standfirst: <string>
  }
*/
// Lib
import SocialSharing from 'vue-social-sharing';

// Components
import WorkMixin from '@/modules/work/WorkMixin';

export default {

  name: 'matter-social-media-sharing',

  mixins: [WorkMixin],

  components: {
    SocialSharing,
  },

  props: ['data', 'href'],

  computed: {

    containerClasses() {
      let deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },

    shareTitle() {
      const { title } = this.data;
      return title || '';
    },

    shareDescription() {
      const { standfirst } = this.data;
      return standfirst || '';
    },

  },

};
</script>

<style lang="scss">
/*
  DO NOT SCOPE – bug in vue-media-share
  https://github.com/nicolasbeauvais/vue-social-sharing/issues/110
*/

@import '~@/styles/_grid.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="matter-social-media-sharing"] {
  width: 100%;

  // media query props
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-bottom: rem($layout--default-module-spacing-desktop);
  }


  .module-layout {

    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      @include ngGrid('desktop');
    }

    .content-container {
      .network-shares {
        .icon {
          cursor: pointer;
          transition: all 250ms;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
    }

    .content-container.mobile {
      grid-column: 1 / -1;
      margin: 0;

      h2 {
        // media query props
        @include serif((40, 40, 0));
        margin-bottom: rem(30px);
      }

      .network-shares {
        span {
          margin-right: rem(10px);
        }
        .icon {
          width: rem(43px);
          height: rem(43px);
        }
      }
    }

    .content-container.tablet {
      grid-column: 2 / -1;
      margin: 0 rem($grid-gap-tablet * -1px); // pull to edges

      h2 {
        // media query props
        @include serif((30, 30, 0));
        margin-bottom: rem(16px);
      }

      .network-shares {
        span {
          margin-right: rem(8px);
        }
        .icon {
          width: rem(30px);
          height: rem(30px);
        }
      }
    }

    .content-container.desktop {
      grid-column: 2 / -1;
      margin: 0;

      h2 {
        // media query props
        @include serif((35, 35, 0));
        margin-bottom: rem(22px);
      }

      .network-shares {
        span {
          margin-right: rem(22px);
        }
        .icon {
          width: rem(42px);
          height: rem(42px);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/matter/SocialMediaSharing.vue